import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Form, actions } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'
import Trash from 'react-icons/lib/md/delete'

import RowSearch from 'components/RowSearch'
import Input from 'components/Input'
import { intRequired, required } from 'utils/validators'

import { searchFee } from './actions'

const validators = {
  'fee_id': { intRequired },
  'amount': { required },
}

class FormPSF extends Component {

  componentDidMount() {
    const { dispatch, item } = this.props
    if (item) {
      dispatch(actions.change('psFeeState', item))
      setTimeout(() => {
        this._focus2._input.select()
      }, 100)
    } else {
      // reset form
      dispatch(actions.reset('psFeeState'))
    }
  }

  _focusNext = () => {
    this._focus2._input.select()
  }

  render() {
    const {
      item,
      onSubmit,
      loading,
      onDelete,
      __searchResults,
    } = this.props

    const isEdit = !!item

    const legend = isEdit ? 'Edit PaymentScheme Fee' : 'Save PaymentScheme Fee'
    let submit = loading ? 'Saving...' : 'Save PaymentScheme Fee'

    if (isEdit) {
      submit = loading ? 'Updating...' : 'Update PaymentScheme Fee'
    }

    return (
      <Form
        model="psFeeState"
        validators={validators}
        className="grid-form"
        onSubmit={onSubmit}
      >
        <Fieldset legend={legend}>
          <RowSearch
            placeholder="Search Fee Code"
            label1="Fee Code"
            label2="Fee Name"
            model="psFeeState.fee_id"
            model1="psFeeState.fee_code"
            model2="psFeeState.fee_name"
            onSearch={searchFee}
            onFinish={this._focusNext}
            results={__searchResults}
            disabled={isEdit}
            autoFocus
            required
          />
          <Row>
            <Field>
              <Input
                ref={(c) => this._focus2 = c}
                model=".amount"
                label="Amount (Php)"
                required
              />
            </Field>
          </Row>
        </Fieldset>
        <fieldset className="modal-footer" disabled={loading}>
          { isEdit &&
            <button onClick={onDelete} type="button" className="btn btn-icon"><Trash /></button> }
          <button type="submit" className="btn btn-success">{submit}</button>
        </fieldset>
      </Form>
    )
  }
}

FormPSF.propTypes = {
  __searchResults: PropTypes.object,
  item: PropTypes.object,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __searchResults: state.paymentscheme.get('feeResults'),
  }
}

export default connect(mapStateToProps)(FormPSF)



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/form-psf.js